module.exports = __webpack_public_path__ + "img/solu2.6a2b33e4.png";